import styled from 'styled-components';
import { mr } from '@upgrade/react-components/Spacing/core';
import Link from '../Link';
import Image from '../Image';

export const StyledContainer = styled.div`
  background-color: ${props => props.theme.palette.backgroundSecondary};
  padding: ${props => props.theme.spacing.xl} 0;
  margin-bottom: ${props => props.theme.spacing.xl};
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
`;

export const StyledImg = styled(Image)`
  width: auto;
  height: 5rem;
  ${mr('none')};
  @media (min-width: ${props => props.theme.mediaMd}) {
    height: 10rem;
    ${mr('2xl')};
  }
`;
